import { Module } from 'vuex'

import { actions } from './user.actions'

export const userModule: Module<unknown, unknown> = {
  actions
}
